<template>
<div>
    <div class="search">
        <div class="paths" style="border: 1px solid #D05959">
            <label class="mdi mdi-folder" style="background-color: #D05959; color: #fff; margin: 0px; padding: 5px 10px 5px 10px"> : <span class="directory">Directory</span> </label>&nbsp;&nbsp;
            <div class="pathUrl" style="display: flex; flex-wrap: wrap; align-content: center;">
                <span v-for="(path,idx) in absolutePath" :key="idx">
                    <span class="path">{{path.path}}</span>
                </span>
            </div>
        </div>
    </div>
</div>
<div class="loader" v-if="loading"></div>
<div class="files-table">
    <table class="table">
        <tr v-for="data in filteredList" :key="data">
            <td class="file-row">
                <div class="flex-nowrap">
                  <div style="flex: 0 0 5%">
                      <img class="folderImg" :src="folderImg" alt="">
                  </div>
                  <div class="file-name-holder">
                      <label class="fileName">{{ data['name'] }}</label>
                  </div>
                </div>
                
                <div class="btn-holder">
                    <div class="button-holder">
                        <div class="edit-button-holder" @click="openFolder(data)">
                            <img :src="folderOpenIcon" class="open-folder-button" alt="">
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </table>
    <table class="table">
        <tr>
            <td style="width:80%;padding:0px;">
                <div class="files" v-for="(file,index) in fileDataList" :key="index">
                    <div class="flex-nowrap">
                      <div class="file-type-holder">
                          <img :src="pdfIcon" v-if="file.name.toLowerCase().endsWith('pdf')" class="fileImg" alt="">
                          <img :src="docxIcon" v-if="file.name.toLowerCase().endsWith('docx')" class="fileImg" alt="">
                          <img :src="docxIcon" v-if="file.name.toLowerCase().endsWith('doc')" class="fileImg" alt="">
                          <img :src="pngIcon" v-if="file.name.toLowerCase().endsWith('png')" class="fileImg" alt="">
                          <img :src="jpgIcon" v-if="file.name.toLowerCase().endsWith('jpg')" class="fileImg" alt="">
                          <img :src="jpegIcon" v-if="file.name.toLowerCase().endsWith('jpeg')" class="fileImg" alt="">
                          <img :src="xlsxIcon" v-if="file.name.toLowerCase().endsWith('xlsx')" class="fileImg" alt="">
                          <img :src="txtIcon" v-if="file.name.toLowerCase().endsWith('txt')" class="fileImg" alt="">
                          <img :src="pptIcon" v-if="file.name.toLowerCase().endsWith('ppt')" class="fileImg" alt="">
                          <img :src="pptIcon" v-if="file.name.toLowerCase().endsWith('pptx')" class="fileImg" alt="">
                          <img :src="csvIcon" v-if="file.name.toLowerCase().endsWith('csv')" class="fileImg" alt="">
                          <img :src="zipIcon" v-if="file.name.toLowerCase().endsWith('zip')" class="fileImg" alt="">
                      </div>
                      <div class="font-weight-bold file-Name">{{file.name}}</div>
                    </div>
                    <div class="file-button-holder">
                        <div class="edit-button-holder" v-if="file.name.toLowerCase().endsWith('pdf')" @click="openDocument(formatPreviewData(file))">
                            <img :src="previewIcon" class="preview-button" alt="">
                        </div>
                        <div class="edit-button-holder" v-if="file.name.toLowerCase().endsWith('txt')" @click="openText(formatPreviewData(file))">
                            <img :src="previewIcon" class="preview-button" alt="">
                        </div>
                        <div class="edit-button-holder" v-if="file.name.toLowerCase().endsWith('png') || file.name.toLowerCase().endsWith('jpg') || file.name.toLowerCase().endsWith('jpeg')" @click="openImage(formatPreviewData(file))">
                            <img :src="previewIcon" class="preview-button" alt="">
                        </div>
                        <div class="download-button-holder" @click="downloadFile(file)">
                            <img :src="downloadBtn" class="download-button" alt="">
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </table>

    <!-- Preview -->
    <div class="preview" v-if="active">
        <div class="viewer-overlay"></div>
        <div class="pdf-background" v-if="pdfView"></div>
        <div class="" :class="`${pdfView ? 'close-btn' : 'close-btn1'}`">
            <button type="button" class="btn btn-sm close-button" @click="close()">
                <span class="mdi mdi-close-circle cancel"></span>
            </button>
        </div>

        <div class="pdf-holder" v-if="pdfView">
            <div class="doc-loader" v-if="docLoading"></div>
            <div class="pdf-topbar">
                <div class="page-navigation">
                    <button type="button" class="btn btn-dark btn-sm nav-button mx-2" @click="changePage('first')">
                        First Page
                    </button>
                    <button type="button" class="btn btn-dark btn-sm nav-button" @click="changePage('previous')">
                        <div class=" nav-icon mdi mdi-menu-left"></div>
                    </button>
                    <label class="page-index">{{currentPage}}/{{numPages}}</label>
                    <button type="button" class="btn btn-dark btn-sm nav-button" @click="changePage('next')">
                        <div class=" nav-icon mdi mdi-menu-right"></div>
                    </button>
                    <button type="button" class="btn btn-dark btn-sm nav-button mx-2" @click="changePage('last')">
                        Last Page
                    </button>
                </div>
            </div>
            <div class="pdf-viewer-holder">
                <pdf class="pdf-viewer" :src="pdfFile" :page="currentPage" :resize="true" />
            </div>
        </div>

        <div v-if="imgView">
            <div class="image-holder">
                <img class="image" :src="imgFile" alt="">
                <div class="image-loader" v-if="imageLoading"></div>
            </div>
        </div>

        <div v-if="txtView">
            <div class="text-holder">
                <object class="text-container" :data="txtFile"></object>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import {
    decryptData
} from '../js/utils/encrypt';
import folderImg from '../assets/folder.svg';
import downloadBtn from '../assets/download-btn.png';
import docxIcon from '../assets/docx-icon.png';
import jpegIcon from '../assets/jpeg-icon.png';
import jpgIcon from '../assets/jpg-icon.png';
import pngIcon from '../assets/png-icon.png';
import txtIcon from '../assets/text-icon.png';
import pdfIcon from '../assets/pdf-icon.png';
import xlsxIcon from '../assets/excel-icon.png';
import folderOpenIcon from '../assets/folder-open.png';
import previewIcon from '../assets/preview-icon.png';
import pptIcon from '../assets/ppt-icon.png';
import csvIcon from '../assets/csv-icon.png';
import zipIcon from '../assets/zip-icon.png';
import pdfvuer from 'pdfvuer';

export default {
    data() {
        return {
            folderOpenIcon: folderOpenIcon,
            previewIcon: previewIcon,
            downloadBtn: downloadBtn,
            docxIcon: docxIcon,
            jpegIcon: jpegIcon,
            jpgIcon: jpgIcon,
            pngIcon: pngIcon,
            txtIcon: txtIcon,
            pdfIcon: pdfIcon,
            pptIcon: pptIcon,
            csvIcon: csvIcon,
            zipIcon: zipIcon,
            xlsxIcon: xlsxIcon,
            loading: false,
            folderImg: folderImg,
            folder: [],
            files: [],
            selected: 'all',
            filter: 'all',
            employees: [],
            loggedInUser: [],
            email: '',
            active: false,
            employeeId: '',
            folderOpen: false,
            permissions: [],
            filesList: '',
            pdfFile: this.pdfFile || '/example.pdf',
            imgFile: this.imgFile || '../assets/loading.gif',
            numPages: 0,
            currentPage: 1,
            pdfdata: undefined,
            pdfView: false,
            imgView: false,
            txtView: false,
            imageLoading: false,
            docLoading: false,
            txtFile: this.txtFile || '/example.txt',
            absolutePath: ['root'],
            FolderName: '',
        };
    },
    components: {
        pdf: pdfvuer
    },
    computed: {
        filteredList() {
            var refined = this.folder;
            var finalData = [];
            if (this.employeeId != 'ADM01') {
                for (let data in refined) {
                    let shortCode = this.employeeId.substring(0, 2);
                    for (let country in refined[data].regions) {
                        if (shortCode == refined[data].regions[country].short_code) {
                            finalData.push(refined[data]);
                        }
                    }
                }
                return finalData;
            } else {
                return refined;
            }
        },
        fileDataList() {
            var refined = this.files;
            var finalData = [];
            if (this.employeeId != 'ADM01') {
                for (let data in refined) {
                    let shortCode = this.employeeId.substring(0, 2);
                    for (let country in refined[data].regions) {
                        if (shortCode == refined[data].regions[country].short_code) {
                            finalData.push(refined[data]);
                        }
                    }
                }
                return finalData;
            } else {
                return refined;
            }
        }

    },
    mounted() {
        this.showAlert;
        this.showSuccess = false;
        this.loading = true;
        var encryptedEmailID = localStorage.getItem('Email');
        const secretKey = process.env.KEY || 'myscecretkey';
        this.email = decryptData(encryptedEmailID, secretKey).replace(/['"]+/g, '');

        //Decrypting Permissions
        let mkLocalData = localStorage.getItem('Permissions');
        if (!mkLocalData) {
            mkLocalData = 'null';
        }
        this.permissions = decryptData(mkLocalData, secretKey);
        var encryptedEmployeeID = localStorage.getItem('EmployeeID');
        if (encryptedEmployeeID != null) {
            this.employeeId = decryptData(encryptedEmployeeID, secretKey).replace(/['"]+/g, '');
        }
        this.filter = this.employeeId.substring(0, 2).toLowerCase();
        axios.get(this.$hostName + '/folders/base').then((response) => {
                var folderData = response.data.data.folder;
                var fileData = response.data.data.files;
                folderData.forEach((element) => {
                    this.folder.push(element);
                });
                fileData.forEach((element) => {
                    this.files.push(element);
                });
                var pathdata = {
                    path: 'root',
                    data: this.folder
                };
                this.absolutePath.push(pathdata);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.loading = false;
            });
    },
    methods: {
        reloadComponent() {
            this.folder = [];
            this.files = [];
            this.absolutePath = [];
            axios.get(this.$hostName + '/folders/base').then((response) => {
                    var folderData = response.data.data.folder;
                    var fileData = response.data.data.files;
                    folderData.forEach((element) => {
                        this.folder.push(element);
                    });
                    fileData.forEach((element) => {
                        this.files.push(element);
                    });
                    var pathdata = {
                        path: 'root',
                        data: this.folder
                    };
                    this.absolutePath.push(pathdata);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.showAlert;
                    this.loading = false;
                });
        },
        downloadFile(fileData) {
            let path = '/' + fileData.name;
            var formData = {
                filePath: path
            };
            axios({
                url: this.$hostName + '/files/downloadAll',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                var fileName = fileData.name;
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();
            });
        },
        formatPreviewData(data) {
            var finalFormat = {
                foldername: this.FolderName,
                filename: data.name
            };
            return finalFormat;
        },
        imageLoad() {
            return this.imgFile;
        },
        close() {
            this.active = false;
            this.pdfView = false;
            this.imgView = false;
            this.txtView = false;
            this.currentPage = 1;
            this.imgFile = '';
        },
        openImage(data) {
            this.imageLoading = true;
            this.imgView = true;
            this.active = true;
            var formData = {
                folderName: data['foldername'],
                fileName: data['filename']
            };
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.imgFile = fileURL;
            }).finally(() => {
                this.active = true;
                this.imgView = true;
                this.imageLoading = false;
            });
        },
        openText(data) {
            this.txtView = true;
            this.active = true;
            var formData = {
                folderName: data['foldername'],
                fileName: data['filename']
            };
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.txtFile = fileURL;
            }).finally(() => {
                this.active = true;
                this.txtView = true;
            });
        },
        openDocument(data) {
            var formData = {
                folderName: data['foldername'],
                fileName: data['filename']
            };
            this.active = true;
            this.docLoading = true;
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.pdfFile = fileURL;
                var self = this;
                self.pdfdata = pdfvuer.createLoadingTask(fileURL);
                self.pdfdata.then(pdf => {
                    this.numPages = pdf.numPages;
                });
                this.pdfView = true;
            }).finally(() => {
                this.docLoading = false;
            });
        },
        changePage(type) {
            if (type == 'next') {
                if (this.currentPage < this.numPages)
                    this.currentPage = this.currentPage + 1;
            } else if (type == 'previous') {
                if (this.currentPage > 1)
                    this.currentPage = this.currentPage - 1;
            } else if (type == 'first') {
                this.currentPage = 1;
            } else if (type == 'last') {
                this.currentPage = this.numPages;
            }
        },
        getImgUrl(filename) {
            try {
                return require(`C:/ProgramData/Scala/hrm-portal/assets/employee/pics/${filename}`);
            } catch (_) {
                return require('../assets/imagealt.png');
            }
        },
        openFolder(data) {
            this.loading = false;
            this.absolutePath = data.name;
            this.folderOpen = true;
            this.$emit('folder-open', this.folderOpen, data);
        },
    }
};
</script>
<style lang="scss" scoped>
.checkbox-container {
    display: flex;
    flex-wrap: wrap;
}

.path:hover {
    cursor: pointer;
}

.paths {
    margin-left: 2%;
    margin-right: 2%;
    font-size: 20px;
    width: 100%;
    display: flex;
}

.fileImg {
    height: 40px;
    margin-right: 10px;
}

.submit-button {
    padding: 10px 20px;
    background-color: #5cb85c;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
}

.submit-button:hover {
    background-color: #4CAF50;
}

.files {
    display: flex;
    align-items: center;
    height: 80px;
    box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: bold;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.file-Name {
    position: relative;
    flex: 0 0 70%;
    font-size: 16px;
}

.file-button-holder {
    flex: 0 0 25%;
    display: flex;
    justify-content: flex-end;
}

.file-type-holder {
    flex: 0 0 5%;
    margin-right: 3px;
}

.flex-nowrap {
  display: flex;
  flex: 0 0 75%;
  align-items: center;
}

@media only screen and (max-width: 575.98px) {
    .files-table {
        height: 79vh !important;
    }

    .flex-nowrap {
      display: flex;
      flex-wrap: nowrap;
      flex: 0 0 100%;
      // align-items: center;
    }

    .file-row {
      padding: 10px !important;
    }

    .pdf-background {
        z-index: -1;
    }

    .previewBtn {
        left: 10px;
        position: initial !important;
        margin-top: 20px;
        height: 6%;
        width: 100%;
        margin-top: 4px !important;
    }

    .btn-holder {
        float: right;
    }

    .nav-button {
        font-size: 12px;
    }

    .pdf-topbar {
        width: 96% !important;
        height: 54px;
        position: absolute;
        top: 140px !important;
        left: calc(50%) !important;
        transform: translate(-50%) !important;
        background-color: white;
        text-align: center;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
    }

    .close-button {
      height: 40px !important;
      width: 40px !important;
    }

    .page-navigation {
        width: 100% !important;
        color: black !important;
        flex-wrap: nowrap !important;
        align-items: center !important;

        button {
          font-size: 14px;
          overflow-y: hidden;
        }
    }

    .pdf-viewer {
        left: calc(50%) !important;
        top: 423px !important;
        width: 300px !important;
    }

    .image-holder {
        left: calc(50%) !important;
    }

    .text-holder {
        background-color: white;
        left: calc(50%) !important;
        width: 80% !important;
        height: 80% !important;
    }

    .close-btn {
        position: absolute;
        top: 50px !important;
        left: 85% !important;
        z-index: 999;
    }

    .close-btn1 {
        position: absolute !important;
        top: 226px !important;
        left: 85% !important;
    }

    .cancel {
        font-size: 45px !important;
        color: #d82d28;
        position: absolute;
        top: 50%;
    }

    .cancel:hover {
        color: #b60a04;
    }

    .edit-button-holder, .download-button-holder {
      width: 40px !important;
      height: 30px !important;
    }

    .directory {
      display: none;
    }
}

@media (min-width: 768px) and (max-width: 991.98px) {
    .close-btn1 {
        position: absolute !important;
        top: 36px !important;
    }

    .cancel {
        font-size: 40px !important;
        color: #d82d28;
        position: absolute !important;
    }

    .cancel:hover {
        color: #b60a04;
    }

    .close-btn {
        position: absolute !important;
        top: 50px !important;
        left: 85% !important;
        z-index: 999;
    }

    .pdf-background {
        z-index: -1;
    }

    .pdf-topbar {
        width: 70% !important;
        height: 48px !important;
        position: absolute;
        top: 140px !important;
        background-color: white;
        text-align: center;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
    }

    .page-navigation {
        width: 100% !important;
        color: black !important;
        left: 50%;
        transform: translate(-50%);
        position: absolute;
        color: white;
        top: 8px !important;
    }

    .pdf-viewer {
        top: 600px !important;
        width: 500px !important;
    }

    .file-name-holder {
      flex: 0 0 90% !important;
    }

    .file-Name {
      flex: 0 0 90%;
    }

}

.previewBtn {
    background-color: #EE3234;
    color: #fff;
    padding: 5px;
    margin-left: 10px;
    margin-top: 0.2rem !important;
}

.pdf-background {
    background-color: #505257;
    height: 97%;
    width: 36%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.image-loader {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    z-index: 999;
}

.doc-loader {
    // background-color: rgba(0, 0, 0, 0.5);
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    backdrop-filter: blur(5px);
    z-index: 1;
}

.image-holder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 90%;
}

.text-holder {
    position: absolute;
    top: 52%;
    left: 50%;
    background-color: white;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 90%;
}

.text-container {
    height: 100%;
    width: 100%;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: contain
}

.file-name-holder {
    flex: 0 0 70%;
}

.btn-holder {
    float: right;
    position: relative;
    flex: 0 0 25%;
}

.nav-icon {
    font-size: 26px;
    position: relative;
    top: -10px;
}

.close-icon {
    font-size: 26px;
    position: relative;
    left: -7px;
    top: -9px;
}

.close-button {
    background-color: white;
    height: 20px;
    width: 20px;
    position: absolute;
    border-radius: 50%;
    padding: 0;
}

.cancel {
    font-size: 30px;
    color: #d82d28;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
}

.cancel:hover {
    color: #b60a04;
}

.nav-button {
    height: 30px;
}

.viewer-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    backdrop-filter: blur(5px);
}

.pdf-topbar {
    width: 32%;
    height: 40px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%);
    background-color: white;
    text-align: center;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
}

.pdf-viewer {
    width: 30%;
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
}

.page-navigation {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    color: white;
    top: 4px;
}

.page-index {
    width: 60px;
    text-align: center;
    color: #000;
}

.close-btn {
    position: absolute;
    top: 4px;
    left: 67.5%;
    z-index: 999;
}

.close-btn1 {
    position: absolute;
    top: 8px;
    left: 90%;
    z-index: 999;
}

.delete-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.delete-button-holder:active {
    transform: scale(0.9);
}

.delete-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:hover {
    cursor: pointer;
}

.delete-button {
    height: 30px;
    width: 30px;
}

.download-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.download-button-holder:active {
    transform: scale(0.9);
}

.download-button-holder {
    transition: transform 100ms ease-in-out;
}

.download-button-holder:hover {
    cursor: pointer;
}

.download-button {
    height: 30px;
    width: 20px;
}

.edit-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.edit-button-holder:active {
    transform: scale(0.9);
}

.edit-button-holder {
    transition: transform 100ms ease-in-out;
}

.edit-button-holder:hover {
    cursor: pointer;
}

.edit-button {
    height: 30px;
    width: 30px;
}

.preview-button {
    height: 20px;
    width: 30px;
}

.open-folder-button {
    height: 25px;
    width: 30px;
}

table {
    border-collapse: separate;
    border-spacing: 0 10px;
}

table td {
    border-top: 0;
}

.upload-file-button {
    background-color: #33a544;
    text-align: center;
    color: #fff;
    font-size: 14px;
    width: 80px;
    height: 30px;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 20px;
    cursor: pointer;
}

table {
    border-collapse: separate;
    border-spacing: 0 10px;
}

.file-row, .files{
    box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 100%;
    padding: 10px 20px;
    font-weight: bold;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.delete-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.button-holder {
    display: flex;
    justify-content: flex-end;
    align-content: center;
}

.open-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 90px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #DDE2FF;
    margin-left: 10px;
}

.open-button {
    color: #4E65FF;
    font-size: 16px;
}

.open-button-holder:active {
    transform: scale(0.9);
}

.open-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:active {
    transform: scale(0.9);
}

.delete-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:hover {
    cursor: pointer;
}

.open-button-holder:hover {
    cursor: pointer;
}

.open-button:hover {
    cursor: pointer;
}

.delete-button {
    height: 30px;
    width: 30px;
}

@media only screen and (max-width: 575.98px) {
    .upload-file-button {
        background-color: #33a544;
        color: #fff;
        font-size: 10px;
        width: 80px;
        height: 30px;
        border-radius: 4px;
        padding: 4px 8px;
        margin-right: 2px !important;
        cursor: pointer;
    }

    .create-folder-button {
        background-color: #33a544;
        color: #fff;
        font-size: 10px;
        width: 80px;
        height: 30px;
        border-radius: 4px;
        padding: 4px 8px;
        margin-right: 2px !important;
        cursor: pointer;
    }

    .files-table {
        height: 79vh !important;
    }

    .manage-files {
        height: 100% !important;
    }

    .pdf-background {
        z-index: -1;
    }

    .openBtn {
        left: 10px;
        position: initial !important;
        margin-top: 20px;
        height: 6%;
        width: 100%;
        margin-top: 4px !important;
    }

    .btn-holder, .file-button-holder {
        float: right;
        flex: 0 0 100%;
    }

    .file-name-holder {
      flex: 0 0 80%;
      padding-left: 10px;
    }

    .file-Name {
      padding-left: 10px;
      flex: 0 0 80% !important;
    }

    .files {
      height: unset;
      padding: 10px;
    }

    .open-folder-button {
      height: 15px;
      width: 20px;
    }

    .download-button {
      height: 16px;
      width: 14px;
    }

    .preview-button {
      height: 16px;
      width: 22px;
    }

    .fileName {
      font-size: 14px !important;
      margin: 0 !important;
    }

    .file-Name {
      font-size: 14px !important;
      margin: 0 !important;
      word-break: break-word;
    }

    .folderImg {
      height: 30px !important;
      width: 30px !important;
    }

    .fileImg {
      width: 30px !important;
      height: unset;
    }

    .pathUrl {
      font-size: 14px;
    }

    .pdfIcon {
        font-size: 26px !important;
        color: #F70000;
    }

    .docxIcon {
        font-size: 26px !important;
        color: #134AC2;
    }

    .imgIcon {
        font-size: 26px !important;
        color: #b41ce6;
    }

    .excelIcon {
        font-size: 26px !important;
        color: green;
    }

    .textIcon {
        font-size: 26px !important;
    }
}

.country-icon-holder {
    display: flex;
}

.folder-name-holder {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    padding: 10px 0px;
}

.folder-name-holder input {
    flex: 0 75%;
}

.folder-name-holder label {
    flex: 0 25%;
    font-size: 14px;
}

.modal {
    display: flex;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

/* Modal Content/Box */
.background {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
}

.modal-content {
    z-index: 3;
    height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40% !important;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

.file-modal-content {
    z-index: 3;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40% !important;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

.file-modal-upload {
    z-index: 3;
    height: 370px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40% !important;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

/* The Close Button */
.close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
    text-shadow: 0;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.modal-header {
    padding: 2px 16px;
    background-color: #d05959;
    color: white;
}

.modal-body {
    padding: 2px 16px;
}

.modal-body label {
    font-size: 14px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 2px 16px;
    background-color: #d05959;
    color: white;
}

.folderImg {
    width: 50px;
    height: 50px;
    margin-right: 10px;
}

.create-folder-button {
    background-color: #33a544;
    text-align: center;
    color: #fff;
    font-size: 14px;
    width: 80px;
    height: 30px;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 20px;
    margin-left: 20px;
    cursor: pointer;
}

.fileName {
    font-size: 18px;
    word-break: break-all;
}

label {
    display: block;
    margin: 0;
}

.files-table {
    height: 82vh;
    overflow: auto;
    padding: 10px;
    font-size: 12px;
}

th {
    margin: 0;
}

tr {
    text-align: left;
}

td {
    text-align: left;
    vertical-align: baseline !important;
}

td:first-child {
    vertical-align: middle !important;
}

thead {
    top: 0;
    position: sticky;
}

.table {
    width: 98%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
}

.icon {
    font-size: 25px;
}

.search {
    width: 100%;
    flex-grow: 1;
    height: 100%;
    position: relative;
    display: flex;

    .icon {
        width: 40px;
        height: 100%;
        font-size: 24px;
        color: #000;
        // opacity: .5;
        position: relative;
        float: left;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    input {
        width: 220px;
        height: 100%;
        position: relative;
        float: left;
        font-size: 14px;
        -webkit-appearance: none;
        outline: 0;
        border-width: 0 0 2px;
        border-color: rgb(40, 40, 102);
        background-color: transparent;
        color: $general-black-light;
        flex-grow: 1;

        &::placeholder {
            opacity: 0.6;
            font-style: italic;
        }
    }
}
</style>
